import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { loadModules } from 'esri-loader';

const USA_PROVIDENCE = [-71.4128, 41.824];

const PrePlansMap = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    let view;

    loadModules(['esri/Map', 'esri/views/MapView'], { css: true }).then(
      ([EsriMap, MapView]) => {
        const map = new EsriMap({ basemap: 'osm' });

        view = new MapView({
          container: mapRef.current,
          map,
          center: USA_PROVIDENCE,
          zoom: 11,
        });
      }
    );

    return () => {
      if (view) {
        view.container = null;
        view.destroy();
      }
    };
  }, []);

  return (
    <Box sx={{ width: '100%', height: 'calc(100% - 57px)' }}>
      <div ref={mapRef} style={{ width: '100%', height: '100%' }} />
    </Box>
  );
};

export default PrePlansMap;
